import { Paper, Stack, Typography } from "@mui/material";
import { ParentSize } from "@visx/responsive";
import CoreMap from "../../../../../../Components/Map";
import useMap from "../../../../../../hooks/useMap";
import { QueryLayer } from "../../../../../../types/queryState";

const DroughtIndicesMap = ({
  color,
  season,
  layers,
}: {
  color: string;
  season: string;
  layers: QueryLayer[];
}) => {
  const { isLoaded, ...viewport } = useMap();

  if (!layers.length) return null;

  return (
    <Stack
      flex={1}
      gap={0.5}
      sx={{
        minHeight: 0,
        minWidth: 0,
        borderRadius: "4px",
        border: `1px solid ${color}`,
        overflow: "hidden",
      }}
    >
      <ParentSize parentSizeStyles={{ width: "100%", height: "100%" }}>
        {(parent) => (
          <CoreMap
            {...viewport}
            layers={layers}
            season={season}
            width="100%"
            height="100%"
          >
            <Stack
              justifyContent="center"
              alignItems="center"
              sx={{
                position: "absolute",
                zIndex: 10,
                bottom: 1,
                right: 1,
              }}
            >
              <Paper sx={{ padding: 0.25 }}>
                <Stack>
                  <Typography variant="body3">
                    Season {layers[0].season}, {layers[0].displayName}
                  </Typography>
                </Stack>
              </Paper>
            </Stack>
          </CoreMap>
        )}
      </ParentSize>
    </Stack>
  );
};

export default DroughtIndicesMap;
